var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 86C67.4198 86 86 67.4198 86 44.5C86 21.5802 67.4198 3 44.5 3C21.5802 3 3 21.5802 3 44.5C3 67.4198 21.5802 86 44.5 86Z",
    stroke: "#34303D",
    strokeWidth: 4.88235
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8438 15.6038C55.9346 12.7134 50.2125 11.0559 44.1022 11.0559C25.852 11.0559 11.056 25.8494 11.056 44.1021C11.056 62.3548 25.8495 77.1507 44.1022 77.1507C62.3549 77.1507 77.1509 62.3572 77.1509 44.1021",
    stroke: "#00D1D2",
    strokeWidth: 4.88235,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.487 19.601C41.2171 19.3632 36.8293 20.2277 32.7533 22.3316C20.5791 28.6153 15.8027 43.5781 22.0874 55.7539C28.372 67.9297 43.3347 72.7061 55.5105 66.4215C67.6864 60.1369 72.4627 45.1741 66.1773 32.9967",
    stroke: "#34303D",
    strokeWidth: 4.88235,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9825 36.6035L64.5517 28.066L73.0901 31.6376",
    stroke: "#34303D",
    strokeWidth: 4.94854,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.eebe4ba9079ef46548b31e3fc7ac2e21.svg";
export { ForwardRef as ReactComponent };